<div class="canvas-tile-display">
  <div class="canvas-header" [attr.data-color]="headerColor">
    @if (displayIcon) {
      <div
        class="icon header-icon"
        (click)="openTileMenu()"
        [innerHtml]="'<i class=\'fa-regular fa-'+displayIcon+'\'></i>'"
      ></div>
    }

    @if (tileMenuOpen) {
      <motn-popover-menu
        [menuTitle]="tileMenuTitle"
        [optionGroup]="tileMenuOptions"
        [overlayPositions]="popoverPositions"
        (clickedOutsideMenu$)="tileMenuOpen = false"
        (clickedOption$)="tileMenuOpen = false"
      ></motn-popover-menu>
    }

    <div class="title">
      <span>{{ displayName }}</span>
    </div>

    <motn-canvas-replay-controls
      class="canvas-controls"
      [loading]="loading()"
      (replayTimestampChange)="onReplayTimestamp($event)"
    ></motn-canvas-replay-controls>
  </div>

  <div class="canvas-container">
    @if (!canvasImageUrl && !loading()) {
      <div class="empty-state">
        <p>No canvas image configured</p>
      </div>
    } @else {
      <div [id]="mapId" class="canvas-map"></div>
      @if (loading()) {
        <div class="loading-skeleton">
          <motn-spinner></motn-spinner>
        </div>
      }
    }
  </div>
</div>

@if (drawerOpen) {
  <motn-canvas-tile-drawer
    [tiles]="drawerTiles"
    [displayName]="displayName"
    [displayIcon]="displayIcon"
    (clickedOutside$)="closeDrawer()"
  ></motn-canvas-tile-drawer>
}

@if (editingTile && tile?.ID) {
  <motn-tile-editor
    [tileId]="tile.ID"
    (closed$)="editingTile = false"
    (deleted$)="editingTile = false"
  ></motn-tile-editor>
}
